<template>
  <div @click="onClick" class="text-white">
    <span class="navbar-toggler-icon"></span>
  </div>
</template>

<script>
export default {
  name: "AppMenuIcon",
  methods: {
    onClick(event) {
      this.$emit("click", event);
    },
  },
};
</script>
